import React from 'react';
import styled from '@emotion/styled';

export const IconVerticalTiles = () => {
  return (
    <StyledIconVerticalTilesSpan className="icon-svg IconVerticalTiles">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <defs />
        <g className="a">
          <rect className="b" width="24" height="24" />
          <g transform="translate(1 3)">
            <g className="c" transform="translate(2)">
              <rect className="e" width="18" height="13" rx="3" />
              <rect className="b" x="1" y="1" width="16" height="11" rx="2" />
            </g>
            <path
              className="d"
              d="M23.961,18.914A3.12,3.12,0,0,1,27.27,15.64c3.428.006,9.4,0,9.4,0s3.389.03,3.389,3.274"
              transform="translate(-21 -0.64)"
            />
          </g>
        </g>
      </svg>
    </StyledIconVerticalTilesSpan>
  );
};

const StyledIconVerticalTilesSpan = styled.span`
  & .a {
    opacity: 0.7;
  }

  & .b {
    fill: none;
  }

  & .c {
    fill: none;
    stroke: #fff;
    stroke-width: 2px;
  }

  & .d {
    fill: none;
    stroke: #fff;
    stroke-width: 2px;
    stroke-linecap: round;
  }

  & .e {
    stroke: none;
  }

  display: inline-block;
  vertical-align: sub;
`;
